import { ComponentProps } from 'react';
import theme from 'App.theme';
import { useHover } from 'hooks/useHover';
import { TurnaroundPageVariant } from '../../pages/Turnaround/models';

type Props = ComponentProps<'button'> & {
  variant?: TurnaroundPageVariant;
  selected?: boolean;
};

export const TurnaroundEntityButton = ({ variant, selected, disabled, style, ...props }: Props) => {
  const [hoverRef, isHovered] = useHover<HTMLButtonElement>();

  return (
    <button
      ref={disabled ? undefined : hoverRef}
      disabled={disabled}
      style={{
        transition: 'background-color 0.2s',
        backgroundColor: selected
          ? variant === 'origin'
            ? theme.colors.primaryMedium
            : theme.colors.amberMedium
          : isHovered
          ? theme.greys.GREYF5
          : theme.colors.white,
        border: 'none',
        borderBottom: `1px solid ${theme.greys.GREYA2}`,
        padding: theme.layout.spacing.small,
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '22px',
        color: theme.colors.black,
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        gap: theme.layout.spacing.small,
        cursor: disabled ? 'default' : 'pointer',
        ...style,
      }}
      {...props}
    />
  );
};
